<template>
  <div class="script-generator">
    <h1 class="bold">
      Script Generator Prompts <br>
    </h1>

    <p v-if="isFetching">
      Is fetching data ...
    </p>

    <form v-else @submit.prevent="handleUpdate">
      <div class="model-info">
        <BaseInput name="model" 
               label="GPT Model"   
               placeholder="Provide GPT model name"
               :disabled="isSaving" 
               :value="data.model"
              @input="handleInput" />
        <BaseInput name="temperature" 
               label="GPT Model Temperature"   
               :disabled="isSaving" 
               placeholder="Provide GPT model temperature" 
               :value="data.temperature"
              @input="handleInput" />
      </div>
      <BaseInput name="systemPrompt" 
               label="System Prompt" 
               :disabled="isSaving" 
               placeholder="Provide system prompt" 
               type="textarea" 
               :value="data.systemPrompt"
               @input="handleInput" />
      <BaseInput name="userPrompt" 
               label="User Prompt"
               :disabled="isSaving"  
               placeholder="Provide user prompt" 
               type="textarea" 
               :value="data.userPrompt"
               @input="handleInput" />
      <button class="purple-btn" 
              :disabled="submitDisabled" 
              type="submit">
          {{isSaving ? 'Saving...' : 'Save changes'}}
      </button>
    </form>
  </div>
</template>

<script setup>
  import { computed } from "vue";
  import { useStore } from "vuex";

  const { state, dispatch, commit } = useStore()
  dispatch('get_script_generator_prompts')

  const isFetching = computed(() => state.reqStatus === "fetching");
  const isSaving = computed(() => state.reqStatus === "sending");
  const submitDisabled = computed(() => isSaving.value || 
    !data.value.model || 
    !data.value.temperature || 
    !data.value.systemPrompt || 
    !data.value.userPrompt
  );
  const data = computed(() => state.scriptGenerator.data)

  function handleInput({ name, value }) {
    commit('SET_SCRIPT_GENERATOR_STATE', {
      key: "data",
      value: {
        ...data.value,
        [name]: value
      }
    })
  }

  function handleUpdate() {
    dispatch('update_script_generator_prompts')
  }
</script>

<style lang="scss">
  @import "../styles/vars";

  .script-generator {
    @media only screen and (min-width: 0) {
      form {
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 24px 0;
        .model-info {
          display: flex;
          gap: 20px;
          .base-input {
            width: 100%;
          }
        }
        textarea {
          min-height: 284px;
        }
      }
    }
  }
</style>